module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crm-master-setup"
  }, [_c('div', {
    staticClass: "setup-row"
  }, [_c('div', {
    staticClass: "setup-section"
  }, [_c('h3', [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "source"
    }
  }, [_vm._v("Source:")]), _vm._v(" "), _c('InputText', {
    staticClass: "w-100",
    attrs: {
      "id": "source",
      "placeholder": "Enter source"
    },
    model: {
      value: (_vm.sourceInput),
      callback: function($$v) {
        _vm.sourceInput = $$v
      },
      expression: "sourceInput"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-success",
    attrs: {
      "label": "Add"
    },
    on: {
      "click": function($event) {
        return _vm.addMasterSetup('source')
      }
    }
  })], 1), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.sourceList,
      "filters": _vm.sourceFilters,
      "scrollable": "",
      "scrollHeight": "150px"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_c('div', {
          staticClass: "flex justify-center items-center h-10 text-gray-500"
        }, [_vm._v("\n            No record found\n          ")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.n"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n            " + _vm._s(slotProps.index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "value",
      "header": "Source"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.editingId === slotProps.data.id && _vm.editingType === 'source') ? _c('InputText', {
          model: {
            value: (_vm.editValue),
            callback: function($$v) {
              _vm.editValue = $$v
            },
            expression: "editValue"
          }
        }) : _c('span', [_vm._v(_vm._s(slotProps.data.value))])]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-inputtext p-component p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.sourceFilters['value']),
            callback: function($$v) {
              _vm.$set(_vm.sourceFilters, 'value', $$v)
            },
            expression: "sourceFilters['value']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Actions",
      "headerStyle": "width: 11em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.editingId === slotProps.data.id && _vm.editingType === 'source') ? _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-check"
          },
          on: {
            "click": function($event) {
              return _vm.updateItem(slotProps.data.id)
            }
          }
        }) : _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.startEditing(slotProps.data.id, slotProps.data.value, 'source')
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteModal(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "setup-section"
  }, [_c('h3', [_vm._v("Ticket Status")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "ticketStatus"
    }
  }, [_vm._v("Ticket Status:")]), _vm._v(" "), _c('InputText', {
    staticClass: "w-100",
    attrs: {
      "id": "ticketStatus",
      "placeholder": "Enter ticket status"
    },
    model: {
      value: (_vm.ticketStatusInput),
      callback: function($$v) {
        _vm.ticketStatusInput = $$v
      },
      expression: "ticketStatusInput"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-success",
    attrs: {
      "label": "Add"
    },
    on: {
      "click": function($event) {
        return _vm.addMasterSetup('ticketStatus')
      }
    }
  })], 1), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.ticketStatusList,
      "filters": _vm.ticketStatusFilters,
      "scrollable": "",
      "scrollHeight": "150px"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_c('div', {
          staticClass: "flex justify-center items-center h-10 text-gray-500"
        }, [_vm._v("\n            No record found\n          ")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.n"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n            " + _vm._s(slotProps.index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "value",
      "header": "Ticket Status"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.editingId === slotProps.data.id && _vm.editingType === 'ticketStatus') ? _c('InputText', {
          model: {
            value: (_vm.editValue),
            callback: function($$v) {
              _vm.editValue = $$v
            },
            expression: "editValue"
          }
        }) : _c('span', [_vm._v(_vm._s(slotProps.data.value))])]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-inputtext p-component p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.ticketStatusFilters['value']),
            callback: function($$v) {
              _vm.$set(_vm.ticketStatusFilters, 'value', $$v)
            },
            expression: "ticketStatusFilters['value']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Actions",
      "headerStyle": "width: 11em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.editingId === slotProps.data.id && _vm.editingType === 'ticketStatus') ? _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-check"
          },
          on: {
            "click": function($event) {
              return _vm.updateItem(slotProps.data.id)
            }
          }
        }) : _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.startEditing(slotProps.data.id, slotProps.data.value, 'ticketStatus')
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteModal(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setup-row"
  }, [_c('div', {
    staticClass: "setup-section"
  }, [_c('h3', [_vm._v("Stage")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "stage"
    }
  }, [_vm._v("Stage:")]), _vm._v(" "), _c('InputText', {
    staticClass: "w-100",
    attrs: {
      "id": "stage",
      "placeholder": "Enter stage"
    },
    model: {
      value: (_vm.stageInput),
      callback: function($$v) {
        _vm.stageInput = $$v
      },
      expression: "stageInput"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-success",
    attrs: {
      "label": "Add"
    },
    on: {
      "click": function($event) {
        return _vm.addMasterSetup('stage')
      }
    }
  })], 1), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.stageList,
      "filters": _vm.stageFilters,
      "scrollable": "",
      "scrollHeight": "150px"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_c('div', {
          staticClass: "flex justify-center items-center h-10 text-gray-500"
        }, [_vm._v("\n            No record found\n          ")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.n"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n            " + _vm._s(slotProps.index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "value",
      "header": "Stage"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.editingId === slotProps.data.id && _vm.editingType === 'stage') ? _c('InputText', {
          model: {
            value: (_vm.editValue),
            callback: function($$v) {
              _vm.editValue = $$v
            },
            expression: "editValue"
          }
        }) : _c('span', [_vm._v(_vm._s(slotProps.data.value))])]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-inputtext p-component p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.stageFilters['value']),
            callback: function($$v) {
              _vm.$set(_vm.stageFilters, 'value', $$v)
            },
            expression: "stageFilters['value']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Actions",
      "headerStyle": "width: 11em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.editingId === slotProps.data.id && _vm.editingType === 'stage') ? _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-check"
          },
          on: {
            "click": function($event) {
              return _vm.updateItem(slotProps.data.id)
            }
          }
        }) : _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.startEditing(slotProps.data.id, slotProps.data.value, 'stage')
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteModal(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "setup-section"
  }, [_c('h3', [_vm._v("Priority")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    attrs: {
      "for": "priority"
    }
  }, [_vm._v("Priority:")]), _vm._v(" "), _c('InputText', {
    staticClass: "w-100",
    attrs: {
      "id": "priority",
      "placeholder": "Enter priority"
    },
    model: {
      value: (_vm.priorityInput),
      callback: function($$v) {
        _vm.priorityInput = $$v
      },
      expression: "priorityInput"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-success",
    attrs: {
      "label": "Add"
    },
    on: {
      "click": function($event) {
        return _vm.addMasterSetup('priority')
      }
    }
  })], 1), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-customers",
    attrs: {
      "value": _vm.priorityList,
      "filters": _vm.priorityFilters,
      "scrollable": "",
      "scrollHeight": "150px"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_c('div', {
          staticClass: "flex justify-center items-center h-10 text-gray-500"
        }, [_vm._v("\n            No record found\n          ")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.n"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n            " + _vm._s(slotProps.index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "value",
      "header": "Priority"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.editingId === slotProps.data.id && _vm.editingType === 'priority') ? _c('InputText', {
          model: {
            value: (_vm.editValue),
            callback: function($$v) {
              _vm.editValue = $$v
            },
            expression: "editValue"
          }
        }) : _c('span', [_vm._v(_vm._s(slotProps.data.value))])]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-inputtext p-component p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.priorityFilters['value']),
            callback: function($$v) {
              _vm.$set(_vm.priorityFilters, 'value', $$v)
            },
            expression: "priorityFilters['value']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Actions",
      "headerStyle": "width: 11em"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.editingId === slotProps.data.id && _vm.editingType === 'priority') ? _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-check"
          },
          on: {
            "click": function($event) {
              return _vm.updateItem(slotProps.data.id)
            }
          }
        }) : _c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.startEditing(slotProps.data.id, slotProps.data.value, 'priority')
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteModal(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.confirmDelete
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47a129be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crm/crmMasterSetup.vue
// module id = 2201
// module chunks = 0